"use strict";

class Broccoli {
  static initClass() {
    this.prototype.DEFAULT_FEATURES = {
      listenForClicks: true,
      listenForHashChange: false
    };
  }
  constructor(options) {
    if (options == null) {
      options = {};
    }
    this.defaultCollection = options.defaultCollection;
    if (!this.defaultCollection) {
      window.$a.error("[Broccoli Error]: must set defaultCollection on instantiation");
      return;
    }
    const defaultFeatures = _.clone(options.defaultFeatures) || {};
    _.defaults(defaultFeatures, this.DEFAULT_FEATURES);
    window.$a.log("[Broccoli Instantiated]:", this);
    this.enable(defaultFeatures);
  }
  // TODO: get rid of this once we make this an IIFE and only have one instance
  // on a page. I think the main blocker right now is the reg path, as we have
  // multiple instances of broccoli being created there.
  disable() {
    $(document).off("click.broccoli", "[data-broccoli-component]");
    return window.$a.log("[Broccoli Features] listenForClicks disabled:", this);
  }
  enable(newEnabledFeatures) {
    if (newEnabledFeatures == null) {
      newEnabledFeatures = {};
    }
    if (!this._enabledFeatures) {
      this._enabledFeatures = {};
    }
    if (newEnabledFeatures.listenForHashChange && !this._enabledFeatures.listenForHashChange) {
      this.notifyPageViewed();
      this._listenForHashChange();
    }
    if (newEnabledFeatures.listenForClicks && !this._enabledFeatures.listenForClicks) {
      this._listenForClicks();
    }
    return _.extend(this._enabledFeatures, newEnabledFeatures);
  }
  notifyPageViewed(eventData, collectionName) {
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    return this.notify("page-viewed", _.extend(eventData, {
      url: window.location.toString()
    }), collectionName);
  }
  notifyComponentClicked(domElement, eventData, collectionName) {
    let componentData;
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    const $domElement = $(domElement);
    if ($domElement.length === 0) {
      window.$a.error("[Broccoli Error]: invalid domElement in notifyComponentClicked");
      return;
    }
    const component = $domElement.attr("data-broccoli-component");
    if (!component) {
      window.$a.error("[Broccoli Error]: invalid component in notifyComponentClicked");
      return;
    }
    collectionName = $domElement.attr("data-broccoli-collection") || collectionName;
    try {
      componentData = JSON.parse($domElement.attr("data-broccoli-data") || "{}");
      if (collectionName === "profile") {
        return componentData = _.extend({
          viewed_user_id: Aedu.User.viewed != null ? Aedu.User.viewed.id : void 0
        }, componentData);
      }
    } catch (error) {
      componentData = {};
      return window.$a.error(`[Broccoli Error] Unable to parse data for ${component}`);
    } finally {
      Kale.notifyEvent({
        collectionName,
        componentName: component,
        componentAction: "clicked",
        eventData: _.extend(eventData, componentData)
      });
    }
  }
  notify(event, eventData, collectionName) {
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    return Kale.notify({
      collectionName,
      eventData: _.extend(eventData, {
        event
      })
    });
  }
  _listenForClicks() {
    $(document).on("click.broccoli", "[data-broccoli-component]", e => {
      return this.notifyComponentClicked(e.currentTarget);
    });
    return window.$a.log("[Broccoli Features] listenForClicks enabled:", this);
  }
  // the intent for this is to log an event in a single page app when the user
  // has changed the page by listening on the 'hashchange' event. Idea from:
  // http://stackoverflow.com/a/2162174
  _listenForHashChange() {
    $(window).on("hashchange.broccoli", () => {
      return this.notifyPageViewed();
    });
    return window.$a.log("[Broccoli Features] listenForHashChange enabled:", this);
  }
}
Broccoli.initClass();
if (window.Aedu) {
  Aedu.Broccoli = Broccoli;
}
window.Broccoli = Broccoli;